import React from 'react'

export const Error = () => {
  return (
    <div style={{textAlign: 'center'}}>Error</div>
  )
}

export default Error